// components/common/PaginationControls.jsx
import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { useTheme, alpha } from "@mui/material/styles";

const PaginationControls = ({ page, setPage, totalPages }) => {
  const theme = useTheme();

  const handlePrev = () => {
    if (page > 1) setPage(page - 1);
  };

  const handleNext = () => {
    if (page < totalPages) setPage(page + 1);
  };

  if (totalPages <= 1) return null;

  // Generate page numbers
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        mt: 4,
        gap: 1,
        py: 1,
        px: 2,
        borderRadius: 2,
        backgroundColor: alpha(theme.palette.primary.main, 0.05),
        flexWrap: "wrap",
      }}
    >
      {/* Previous Button */}
      <IconButton
        onClick={handlePrev}
        disabled={page === 1}
        sx={{
          color: theme.palette.primary.main,
          "&:hover": { backgroundColor: alpha(theme.palette.primary.main, 0.15) },
        }}
      >
        <ArrowBackIos fontSize="small" />
      </IconButton>

      {/* Page Numbers */}
      {pages.map((p) => (
        <Typography
          key={p}
          onClick={() => setPage(p)}
          sx={{
            cursor: "pointer",
            px: 1.5,
            py: 0.5,
            borderRadius: 1,
            minWidth: 32,
            textAlign: "center",
            fontWeight: page === p ? "bold" : 500,
            color: page === p ? theme.palette.primary.contrastText : theme.palette.primary.main,
            backgroundColor:
              page === p ? theme.palette.primary.main : "transparent",
            "&:hover": {
              backgroundColor: alpha(theme.palette.primary.main, 0.2),
            },
            transition: "all 0.2s ease",
          }}
        >
          {p}
        </Typography>
      ))}

      {/* Next Button */}
      <IconButton
        onClick={handleNext}
        disabled={page === totalPages}
        sx={{
          color: theme.palette.primary.main,
          "&:hover": { backgroundColor: alpha(theme.palette.primary.main, 0.15) },
        }}
      >
        <ArrowForwardIos fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default PaginationControls;